import React from 'react';
import './Loader.scss';

const Loader = () => {
    return (
        <div className="loader">
            <div className="loader-spinner"></div>
            <div>Načítám...</div>
        </div>
    );
};

export default Loader;
